import resistenzeImg from './resistenze.png';
import condensatoriImg from './condensatori.png';
import connettoriImg from './connettori.png';
import scaffaleImg from './scaffale.jpg';
import fusibiliImg from './fusibili.png';
import integratiImg from './integrati.png';
import pcbImg from './pcb.png';
import varieImg from './varie.png';

import React, { useState, useEffect } from 'react';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, ref, onValue, push, set, update } from "firebase/database";

// --- CONFIGURAZIONE FIREBASE (Realtime Database) ---
const firebaseConfig = {
  apiKey: "AIzaSyCuLMlF_GrFKTpYEAfADBp-Ci4Qh-OdWUs",
  authDomain: "inventario-tdyna.firebaseapp.com",
  projectId: "inventario-tdyna",
  storageBucket: "inventario-tdyna.appspot.com",
  messagingSenderId: "625028722581",
  appId: "1:625028722581:web:c22dbb2f1ec9b3ce14509c",
  measurementId: "G-JZJ4XZDGGK"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);

// --- COSTANTI ---
const CATEGORIE = [
  { nome: "Resistenze", icona: resistenzeImg },
  { nome: "Condensatori", icona: condensatoriImg },
  { nome: "Connettori", icona: connettoriImg },
  { nome: "Fusibili", icona: fusibiliImg },
  { nome: "Integrati", icona: integratiImg },
  { nome: "PCB", icona: pcbImg },
  { nome: "Varie", icona: varieImg }
];

const MAPPA = [
  ["A", "B", "C", "D", "E", "F"],
  ["G", "H", "I", "L", "M", "N"],
  ["O", "P", "Q", "R", "S", "T"],
  ["U", "V", "Z", "X", "Y", "J"],
  ["W", "AA", "BB", "CC","DD", "EE", "FF"],
  ["GG", "HH", "II", "LL", "MM", "NN"],
  ["OO", "PP","QQ", "RR", "SS", "TT"],
  ["UU", "VV", "ZZ", "XX", "YY", "JJ"]
];

const BLU_GRADIENT = "linear-gradient(135deg, #0f2027 0%, #2c5364 100%)";
const BLU_ACCENT = "#1976d2";
const BLU_ACCENT2 = "#1565c0";
const BLU_ACCENT3 = "#64b5f6";
const ROSSO_ACCENT = "#e53935";
const ROSSO_CHIARO = "#ffcdd2";
const BLU_CHIARO = "#e3f2fd";
const BIANCO = "#fff";
const SOGLIA_BASSA = 100;

// --- ANIMAZIONE PALLINO LAMPEGGIANTE ---
if (typeof window !== "undefined" && !document.getElementById("lampeggia-keyframes")) {
  const style = document.createElement('style');
  style.id = "lampeggia-keyframes";
  style.innerHTML = `
    @keyframes lampeggia {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.2; }
    }
  `;
  document.head.appendChild(style);
}

// --- COMPONENTE PRINCIPALE ---
const App = () => {
  const [modificaAttiva, setModificaAttiva] = useState(false);
  const [prodottoModificato, setProdottoModificato] = useState(null);
  const [hoverCategoria, setHoverCategoria] = useState(null); // <--- mettila qui!
  const [categoriaSelezionata, setCategoriaSelezionata] = useState(null);
  const [prodottiFiltrati, setProdottiFiltrati] = useState([]);
  const [quantitaRichiesta, setQuantitaRichiesta] = useState("");
  const [quantitaAggiunta, setQuantitaAggiunta] = useState("");
  const [prodottoSelezionato, setProdottoSelezionato] = useState(null);
  const [posizioneSelezionata, setPosizioneSelezionata] = useState(null);
  const [mostraScaffale, setMostraScaffale] = useState(false);
  const [prodotti, setProdotti] = useState([]);
  const valoreTotaleMagazzino = prodotti.reduce(
  (tot, p) => tot + (parseFloat(p.prezzo || 0) * parseInt(p.quantita || 0)), 0);
  const [hoverScaffale, setHoverScaffale] = useState(false);
  const [visualizzaDettaglioPosizione, setVisualizzaDettaglioPosizione] = useState(false);
  const [soloScorteBasse, setSoloScorteBasse] = useState(false);
  const [mostraFormAggiunta, setMostraFormAggiunta] = useState(false);
  const [mostraPaginaProdotto, setMostraPaginaProdotto] = useState(false);
    const [nuovoProdotto, setNuovoProdotto] = useState({
      nome: "",
      dettagli: "",
      posizione: "",
      quantita: "",
      prezzo: "" // <--- aggiunto campo prezzo
    });
  const [prezziVisibili, setPrezziVisibili] = useState(false);
  const chiediPasswordPrezzi = () => {
    const pwd = prompt("Inserisci la password per vedere i prezzi:");
    if (pwd === "tdynaprezzi") { // Cambia qui la password se vuoi!
      setPrezziVisibili(true);
    } else {
      alert("Password errata!");
    }
  };

  // --- CARICAMENTO E SINCRONIZZAZIONE DATI IN TEMPO REALE ---
  useEffect(() => {
    const prodottiRef = ref(db, "prodotti");
    const unsubscribe = onValue(prodottiRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setProdotti(Object.values(data));
      } else {
        setProdotti([]);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (categoriaSelezionata) {
      setProdottiFiltrati(prodotti.filter(p => p.tipo === categoriaSelezionata));
    }
  }, [prodotti, categoriaSelezionata]);

  // --- AGGIUNTA PRODOTTO ---
  const handleAggiungiProdotto = () => {
    if (!nuovoProdotto.nome || !nuovoProdotto.posizione || !nuovoProdotto.quantita) {
      alert("Compila tutti i campi obbligatori");
      return;
    }
    const prodotto = {
      id: Date.now(),
      nome: nuovoProdotto.nome,
      tipo: categoriaSelezionata,
      dettagli: nuovoProdotto.dettagli,
      posizione: nuovoProdotto.posizione,
      quantita: parseInt(nuovoProdotto.quantita),
      prezzo: parseFloat(nuovoProdotto.prezzo) // <--- aggiungi questo
    };
    const newProdRef = push(ref(db, "prodotti"));
    set(newProdRef, prodotto).then(() => {
      setNuovoProdotto({
        nome: "",
        dettagli: "",
        posizione: "",
        quantita: ""
      });
      setMostraFormAggiunta(false);
      alert("Prodotto aggiunto con successo!");
      window.location.reload();
    });
  };

  // --- PRELIEVO PRODOTTO ---
  const prelevaProdotto = () => {
    if (!quantitaRichiesta || isNaN(quantitaRichiesta)) {
      alert("Inserisci una quantità valida");
      return;
    }
    const quantita = parseInt(quantitaRichiesta);
    if (quantita <= 0) {
      alert("La quantità deve essere maggiore di 0");
      return;
    }
    if (prodottoSelezionato.quantita < quantita) {
      alert(`Quantità insufficiente! Disponibili solo ${prodottoSelezionato.quantita} unità`);
      return;
    }
    const prodottiRef = ref(db, "prodotti");
    onValue(prodottiRef, (snapshot) => {
      const data = snapshot.val();
      for (let key in data) {
        if (data[key].id === prodottoSelezionato.id) {
          update(ref(db, `prodotti/${key}`), {
            quantita: data[key].quantita - quantita
          }).then(() => {
            setQuantitaRichiesta("");
            window.location.reload();
            // Non chiudere la pagina, la UI si aggiorna in automatico
          });
          break;
        }
      }
    }, { onlyOnce: true });
  };

  // --- AGGIUNGI SCORTE ---
  const aggiungiScorte = () => {
    if (!quantitaAggiunta || isNaN(quantitaAggiunta)) {
      alert("Inserisci una quantità valida");
      return;
    }
    const quantita = parseInt(quantitaAggiunta);
    if (quantita <= 0) {
      alert("La quantità deve essere maggiore di 0");
      return;
    }
    const prodottiRef = ref(db, "prodotti");
    onValue(prodottiRef, (snapshot) => {
      const data = snapshot.val();
      for (let key in data) {
        if (data[key].id === prodottoSelezionato.id) {
          update(ref(db, `prodotti/${key}`), {
            quantita: data[key].quantita + quantita
          }).then(() => {
            setQuantitaAggiunta("");
            window.location.reload();
          });
          break;
        }
      }
    }, { onlyOnce: true });
  };

  // --- ELIMINA PRODOTTO ---
  const eliminaProdotto = (prodotto) => {
    const conferma = window.confirm("Sei sicuro di voler eliminare questo prodotto?");
    if (!conferma) return;
  
    const prodottiRef = ref(db, "prodotti");
    onValue(prodottiRef, (snapshot) => {
      const data = snapshot.val();
      for (let key in data) {
        if (data[key].id === prodotto.id) {
          set(ref(db, `prodotti/${key}`), null).then(() => {
            setProdottoSelezionato(null);
            setMostraPaginaProdotto(false);
            alert("Prodotto eliminato!");
            window.location.reload();
          });
          break;
        }
      }
    }, { onlyOnce: true });
  };

  // --- RENDER MAPPA SCAFFALE ---
  const renderMappa = () => {
    const posizioniDaMostrare = soloScorteBasse
      ? MAPPA.flat().filter(pos =>
          prodotti.filter(p => p.posizione === pos && p.quantita <= SOGLIA_BASSA).length > 0
        )
      : MAPPA.flat();

    return (
      <div style={{
        margin: "30px auto",
        maxWidth: "900px",
        background: BLU_GRADIENT,
        borderRadius: "18px",
        boxShadow: "0 8px 32px 0 rgba(31,38,135,0.37)",
        padding: "32px 24px"
      }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px"
        }}>
          <h2 style={{ margin: 0, color: BIANCO, letterSpacing: 1 }}>Scaffale completo</h2>
          <label style={{ display: "flex", alignItems: "center", gap: "10px", color: BIANCO }}>
            <input
              type="checkbox"
              checked={soloScorteBasse}
              onChange={() => setSoloScorteBasse(!soloScorteBasse)}
              style={{ accentColor: ROSSO_ACCENT }}
            />
            Mostra solo scorte basse
          </label>
        </div>
        {soloScorteBasse && (
          <div style={{
            backgroundColor: ROSSO_CHIARO,
            padding: "10px",
            borderRadius: "6px",
            border: `1px solid ${ROSSO_ACCENT}`,
            marginBottom: "20px",
            color: ROSSO_ACCENT,
            fontWeight: 600
          }}>
            <strong>Attenzione:</strong> Visualizzando solo le sezioni con scorte basse
          </div>
        )}
        <div style={{
          display: "grid",
          gridTemplateColumns: `repeat(${MAPPA[0].length}, 90px)`,
          gap: "18px",
          justifyContent: "center",
        }}>
          {posizioniDaMostrare.map((pos) => {
            const prodottiInSezione = prodotti.filter(p => p.posizione === pos);
            const lowStock = prodottiInSezione.some(p => p.quantita <= SOGLIA_BASSA);
            const highlight = prodottoSelezionato?.posizione === pos;
            return (
              <div
                key={pos}
                onClick={() => {
                  setPosizioneSelezionata(pos);
                  setVisualizzaDettaglioPosizione(true);
                  setMostraPaginaProdotto(false);
                }}
                style={{
                  height: 90,
                  borderRadius: 12,
                  background: highlight
                    ? `linear-gradient(135deg, #b2ff59 0%, #00e676 100%)`
                    : lowStock
                    ? `linear-gradient(135deg, #ffcdd2 0%, #e57373 100%)`
                    : `linear-gradient(135deg, #bbdefb 0%, #1976d2 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 22,
                  boxShadow: highlight
                    ? "0 0 18px 4px #00e676"
                    : lowStock
                    ? "0 0 12px 2px #e57373"
                    : "0 2px 8px #1565c033",
                  cursor: "pointer",
                  position: "relative",
                  color: highlight ? "#222" : lowStock ? ROSSO_ACCENT : BLU_ACCENT,
                  transition: "all 0.2s",
                  border: highlight
                    ? "3px solid #00e676"
                    : lowStock
                    ? `2px solid ${ROSSO_ACCENT}`
                    : `1px solid ${BLU_ACCENT3}`,
                  userSelect: "none"
                }}
                title={`Sezione ${pos}${lowStock ? " - Scorte basse!" : ""}`}
              >
                {pos}
                {prodottiInSezione.length > 0 && (
                  <div style={{
                    position: "absolute",
                    bottom: 8,
                    right: 10,
                    fontSize: 13,
                    color: lowStock ? ROSSO_ACCENT : BLU_ACCENT2,
                    background: lowStock ? "#fff" : "#e3f2fd",
                    borderRadius: 8,
                    padding: "2px 8px",
                    fontWeight: 600,
                    boxShadow: "0 1px 4px #0001"
                  }}>
                    {prodottiInSezione.length} articoli
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // --- RENDER PAGINA PRODOTTO ---
  const renderPaginaProdotto = () => {
    if (!prodottoSelezionato) return null;
    return (
      <div style={{
        minHeight: "100vh",
        background: BLU_CHIARO,
        padding: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <button
          onClick={() => setMostraPaginaProdotto(false)}
          style={{
            padding: "10px 22px",
            marginBottom: "28px",
            background: BLU_ACCENT,
            color: BIANCO,
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "0 2px 8px #1976d244"
          }}
        >
          ← Torna alla lista prodotti
        </button>
        <div style={{
          padding: "24px",
          border: `1.5px solid ${BLU_ACCENT3}`,
          borderRadius: "12px",
          background: "#fff",
          marginBottom: "24px",
          maxWidth: "400px",
          width: "100%"
        }}>
          <h2 style={{ color: BLU_ACCENT2, marginTop: 0 }}>{prodottoSelezionato.nome}</h2>
          <div style={{ marginBottom: "10px" }}>
            <strong>Dettagli:</strong> {prodottoSelezionato.dettagli}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Posizione:</strong> {prodottoSelezionato.posizione}
          </div>
          <div style={{
            marginBottom: "10px",
            color: prodottoSelezionato.quantita <= SOGLIA_BASSA ? ROSSO_ACCENT : BLU_ACCENT2,
            fontWeight: "bold"
          }}>
            <strong>Quantità disponibile:</strong> {prodottoSelezionato.quantita}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Categoria:</strong> {prodottoSelezionato.tipo}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Prezzo unitario:</strong> {prezziVisibili && prodottoSelezionato.prezzo !== undefined && prodottoSelezionato.prezzo !== null ? prodottoSelezionato.prezzo.toFixed(3) + " €" : "••••"}
          </div>
          <div style={{ marginBottom: "10px" }}>
            {!prezziVisibili && (
              <button
                onClick={chiediPasswordPrezzi}
                style={{
                  padding: "8px 14px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: 600,
                  marginBottom: "18px"
                }}
              >
                Sblocca prezzi
              </button>
            )}
            <strong>Valore totale:</strong> {prezziVisibili && prodottoSelezionato.prezzo !== undefined && prodottoSelezionato.prezzo !== null ? (prodottoSelezionato.prezzo * prodottoSelezionato.quantita).toFixed(2) + " €" : "••••"}          
          </div>
            <button
              onClick={() => {
                setProdottoModificato({ ...prodottoSelezionato });
                setModificaAttiva(true);
              }}
              style={{
                padding: "8px 14px",
                background: "#64b5f6",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: 600,
                marginTop: "10px"
              }}
            >
              Modifica caratteristiche
            </button>

            {modificaAttiva && (
              <div style={{ marginTop: "18px", background: "#fff", padding: "18px", borderRadius: "10px", border: "1.5px solid #64b5f6", display: "flex", flexDirection: "column", gap: "8px" }}>
                <input
                  type="text"
                  value={prodottoModificato.nome}
                  onChange={e => setProdottoModificato({ ...prodottoModificato, nome: e.target.value })}
                  placeholder="Nome"
                />
                <input
                  type="text"
                  value={prodottoModificato.dettagli}
                  onChange={e => setProdottoModificato({ ...prodottoModificato, dettagli: e.target.value })}
                  placeholder="Dettagli"
                />
                <input
                  type="text"
                  value={prodottoModificato.posizione}
                  onChange={e => setProdottoModificato({ ...prodottoModificato, posizione: e.target.value })}
                  placeholder="Posizione"
                />
                <input
                  type="number"
                  value={prodottoModificato.quantita}
                  onChange={e => setProdottoModificato({ ...prodottoModificato, quantita: e.target.value })}
                  placeholder="Quantità"
                />
                <input
                  type="number"
                  value={prodottoModificato.prezzo}
                  onChange={e => setProdottoModificato({ ...prodottoModificato, prezzo: e.target.value })}
                  placeholder="Prezzo"
                />
                <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                  <button onClick={salvaModificheProdotto} style={{ background: "#1976d2", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 14px", fontWeight: 600 }}>Salva modifiche</button>
                  <button onClick={() => setModificaAttiva(false)} style={{ background: "#e53935", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 14px", fontWeight: 600 }}>Annulla</button>
                </div>
              </div>
            )}
          <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap", marginTop: "18px" }}>
            <input
              type="number"
              placeholder="Quantità da prelevare"
              value={quantitaRichiesta}
              onChange={(e) => setQuantitaRichiesta(e.target.value)}
              style={{ padding: "10px", width: "120px", borderRadius: "6px", border: `1.5px solid ${BLU_ACCENT3}` }}
              min="1"
            />
            <button
              onClick={prelevaProdotto}
              style={{
                padding: "8px 14px",
                background: BLU_ACCENT,
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: 600
              }}
            >
              Preleva
            </button>
            <input
              type="number"
              placeholder="Aggiungi scorte"
              value={quantitaAggiunta}
              onChange={(e) => setQuantitaAggiunta(e.target.value)}
              style={{ padding: "10px", width: "120px", borderRadius: "6px", border: `1.5px solid ${BLU_ACCENT3}` }}
              min="1"
            />
            <button
              onClick={aggiungiScorte}
              style={{
                padding: "8px 14px",
                background: BLU_ACCENT2,
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: 600
              }}
            >
              Aggiungi scorte
            </button>
            <button
              onClick={() => eliminaProdotto(prodottoSelezionato)}
              style={{
                padding: "8px 14px",
                background: ROSSO_ACCENT,
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: 600
              }}
            >
              Elimina
            </button>
          </div>
        </div>
        <div style={{ marginTop: "30px", width: "100%", maxWidth: "900px" }}>
          <h3 style={{ color: BLU_ACCENT2 }}>Posizione nello scaffale</h3>
          <p>Sezione evidenziata in verde: {prodottoSelezionato.posizione}</p>
          <p>Clicca sulla sezione per visualizzare i prodotti in dettaglio</p>
          {renderMappa()}
        </div>
      </div>
    );
  };

  // --- RENDER DETTAGLIO POSIZIONE ---
  const renderDettaglioPosizione = () => {
    const prodottiInPosizione = prodotti
      .filter(p => p.posizione === posizioneSelezionata)
      .sort((a, b) => a.id - b.id);

    const prodottiLowStock = prodottiInPosizione.filter(p => p.quantita <= SOGLIA_BASSA);

    return (
      <div style={{ padding: "32px", maxWidth: "1100px", margin: "0 auto" }}>
        <button
          onClick={() => setVisualizzaDettaglioPosizione(false)}
          style={{
            padding: "10px 22px",
            marginBottom: "28px",
            background: BLU_ACCENT,
            color: BIANCO,
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "0 2px 8px #1976d244"
          }}
        >
          ← Torna alla mappa
        </button>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px"
        }}>
          <h2 style={{ margin: 0, color: BLU_ACCENT2 }}>Sezione {posizioneSelezionata}</h2>
          {prodottiLowStock.length > 0 && (
            <div style={{
              background: ROSSO_CHIARO,
              color: ROSSO_ACCENT,
              padding: "7px 16px",
              borderRadius: "6px",
              border: `1px solid ${ROSSO_ACCENT}`,
              fontWeight: "bold"
            }}>
              {prodottiLowStock.length} prodotti con scorte basse
            </div>
          )}
        </div>
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "18px",
          justifyContent: "flex-start"
        }}>
          {prodottiInPosizione.map((p, idx) => (
            <div
              key={p.id}
              style={{
                width: "70px",
                height: "140px",
                background: p.id === prodottoSelezionato?.id
                  ? "linear-gradient(135deg, #e3f2fd 0%,rgb(32, 225, 14) 100%)"
                  : p.quantita <= SOGLIA_BASSA
                  ? "linear-gradient(135deg, #ffcdd2 0%, #e57373 100%)"
                  : "linear-gradient(135deg, #f5fafd 0%, #bbdefb 100%)",
                border: p.id === prodottoSelezionato?.id
                  ? "3px solidrgb(15, 216, 58)"
                  : p.quantita <= SOGLIA_BASSA
                  ? `2px solid ${ROSSO_ACCENT}`
                  : `1px solid ${BLU_ACCENT3}`,
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                boxShadow: p.id === prodottoSelezionato?.id
                  ? "0 0 18px #1976d2aa"
                  : "0 2px 8px #1565c033",
                cursor: "pointer",
                transition: "all 0.2s",
                fontSize: "2.2rem",
                fontWeight: "bold",
                color: p.id === prodottoSelezionato?.id ? BLU_ACCENT : p.quantita <= SOGLIA_BASSA ? ROSSO_ACCENT : "#222",
                flexDirection: "column"
              }}
              title={`Prodotto #${idx + 1}`}
              onClick={() => setProdottoSelezionato(p)}
            >
              <span>{idx + 1}</span>
            </div>
          ))}
        </div>
        <div style={{ marginTop: "32px" }}>
          <h3 style={{ color: BLU_ACCENT2 }}>Dettagli prodotto</h3>
          {prodottoSelezionato ? (
            <div style={{
              padding: "18px",
              border: `1.5px solid ${BLU_ACCENT3}`,
              borderRadius: "12px",
              background: BLU_CHIARO,
              marginBottom: "24px",
              maxWidth: "400px"
            }}>
              <div style={{ marginBottom: "10px" }}>
                <strong>Nome:</strong> {prodottoSelezionato.nome}
              </div>
              <div style={{ marginBottom: "10px" }}>
                <strong>Dettagli:</strong> {prodottoSelezionato.dettagli}
              </div>
              <div style={{ marginBottom: "10px" }}>
                <strong>Quantità:</strong> {prodottoSelezionato.quantita}
              </div>
              <div style={{ marginBottom: "10px" }}>
                <strong>Categoria:</strong> {prodottoSelezionato.tipo}
              </div>
              <div style={{ marginBottom: "10px" }}>
                <strong>Prezzo unitario:</strong> {prodottoSelezionato.prezzo?.toFixed(3)} €
              </div>
              <div style={{ marginBottom: "10px" }}>
                <strong>Valore totale:</strong> {(prodottoSelezionato.prezzo * prodottoSelezionato.quantita).toFixed(2)} €
              </div>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                <input
                  type="number"
                  placeholder="Quantità da prelevare"
                  value={quantitaRichiesta}
                  onChange={(e) => setQuantitaRichiesta(e.target.value)}
                  style={{ padding: "10px", width: "120px", borderRadius: "6px", border: `1.5px solid ${BLU_ACCENT3}` }}
                  min="1"
                />
                <button
                  onClick={prelevaProdotto}
                  style={{
                    padding: "8px 14px",
                    background: BLU_ACCENT,
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: 600
                  }}
                >
                  Preleva
                </button>
                <input
                  type="number"
                  placeholder="Aggiungi scorte"
                  value={quantitaAggiunta}
                  onChange={(e) => setQuantitaAggiunta(e.target.value)}
                  style={{ padding: "10px", width: "120px", borderRadius: "6px", border: `1.5px solid ${BLU_ACCENT3}` }}
                  min="1"
                />
                <button
                  onClick={aggiungiScorte}
                  style={{
                    padding: "8px 14px",
                    background: BLU_ACCENT2,
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: 600
                  }}
                >
                  Aggiungi scorte
                </button>
                <button
                  onClick={() => eliminaProdotto(prodottoSelezionato)}
                  style={{
                    padding: "8px 14px",
                    background: ROSSO_ACCENT,
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: 600
                  }}
                >
                  Elimina
                </button>
              </div>
            </div>
          ) : (
            <div style={{ color: "#888" }}>Clicca su un rettangolo per vedere i dettagli</div>
          )}
        </div>
      </div>
    );
  };

  const salvaModificheProdotto = () => {
  const prodottiRef = ref(db, "prodotti");
  onValue(prodottiRef, (snapshot) => {
    const data = snapshot.val();
    for (let key in data) {
      if (data[key].id === prodottoModificato.id) {
        update(ref(db, `prodotti/${key}`), {
          ...prodottoModificato,
          quantita: parseInt(prodottoModificato.quantita),
          prezzo: parseFloat(prodottoModificato.prezzo)
        }).then(() => {
          setModificaAttiva(false);
          setProdottoSelezionato({ ...prodottoModificato });
          alert("Prodotto modificato!");
          window.location.reload();
        });
        break;
      }
    }
  }, { onlyOnce: true });
};
  // --- FORM AGGIUNTA PRODOTTO ---
  const renderFormAggiunta = () => {
    return (
      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(30,40,80,0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}>
        <div style={{
          background: BLU_CHIARO,
          padding: "38px 32px",
          borderRadius: "16px",
          width: "420px",
          maxWidth: "95vw",
          boxShadow: "0 8px 32px 0 rgba(31,38,135,0.37)"
        }}>
          <h2 style={{ marginTop: 0, color: BLU_ACCENT2 }}>Aggiungi nuovo prodotto</h2>
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "500", color: BLU_ACCENT2 }}>Nome*</label>
            <input
              type="text"
              value={nuovoProdotto.nome}
              onChange={(e) => setNuovoProdotto({ ...nuovoProdotto, nome: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                border: `1.5px solid ${BLU_ACCENT3}`,
                borderRadius: "6px",
                fontSize: "15px"
              }}
              placeholder="Es: Resistenza 1kΩ"
            />
          </div>
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "500", color: BLU_ACCENT2 }}>Dettagli</label>
            <input
              type="text"
              value={nuovoProdotto.dettagli}
              onChange={(e) => setNuovoProdotto({ ...nuovoProdotto, dettagli: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                border: `1.5px solid ${BLU_ACCENT3}`,
                borderRadius: "6px",
                fontSize: "15px"
              }}
              placeholder="Es: Passo 10"
            />
          </div>
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "500", color: BLU_ACCENT2 }}>Posizione*</label>
            <select
              value={nuovoProdotto.posizione}
              onChange={(e) => setNuovoProdotto({ ...nuovoProdotto, posizione: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                border: `1.5px solid ${BLU_ACCENT3}`,
                borderRadius: "6px",
                fontSize: "15px"
              }}
            >
              <option value="">Seleziona posizione</option>
              {MAPPA.flat().map(pos => (
                <option key={pos} value={pos}>{pos}</option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: "28px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "500", color: BLU_ACCENT2 }}>Quantità*</label>
            <input
              type="number"
              value={nuovoProdotto.quantita}
              onChange={(e) => setNuovoProdotto({ ...nuovoProdotto, quantita: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                border: `1.5px solid ${BLU_ACCENT3}`,
                borderRadius: "6px",
                fontSize: "15px"
              }}
              placeholder="Es: 100"
              min="1"
            />
          </div>
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: "500", color: BLU_ACCENT2 }}>Prezzo unitario (€)*</label>
            <input
              type="number"
              value={nuovoProdotto.prezzo}
              onChange={(e) => setNuovoProdotto({ ...nuovoProdotto, prezzo: e.target.value })}
              style={{
                width: "100%",
                padding: "10px",
                border: `1.5px solid ${BLU_ACCENT3}`,
                borderRadius: "6px",
                fontSize: "15px"
              }}
              placeholder="Es: 0.25"
              min="0"
              step="0,001"
              required
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <button
              onClick={() => setMostraFormAggiunta(false)}
              style={{
                padding: "10px 18px",
                background: "#fff",
                border: `1.5px solid ${BLU_ACCENT3}`,
                borderRadius: "6px",
                cursor: "pointer",
                color: BLU_ACCENT2,
                fontWeight: 600
              }}
            >
              Annulla
            </button>
            <button
              onClick={handleAggiungiProdotto}
              style={{
                padding: "10px 18px",
                background: BLU_ACCENT,
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: 600
              }}
            >
              Aggiungi
            </button>
          </div>
        </div>
      </div>
    );
  };

  // --- RICERCA PRODOTTO ---
  const renderRicercaProdotto = () => {
    return (
      <div style={{ padding: "32px", maxWidth: "900px", margin: "0 auto" }}>
        <button
          onClick={() => {
            setCategoriaSelezionata(null);
            setProdottoSelezionato(null);
            setPosizioneSelezionata(null);
          }}
          style={{
            padding: "10px 22px",
            marginBottom: "24px",
            background: BLU_ACCENT,
            color: BIANCO,
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "0 2px 8px #1976d244"
          }}
        >
          ← Torna alla home
        </button>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
          <h2 style={{ margin: 0, color: BLU_ACCENT2 }}>Ricerca {categoriaSelezionata}</h2>
          <button
            onClick={() => setMostraFormAggiunta(true)}
            style={{
              padding: "10px 18px",
              background: BLU_ACCENT2,
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 16
            }}
          >
            + Aggiungi prodotto
          </button>
        </div>
        <input
          type="text"
          placeholder={`Cerca ${categoriaSelezionata}...`}
          onChange={(e) => {
            let term = e.target.value.trim().toLowerCase();
            if (!term) {
              setProdottiFiltrati(prodotti.filter(p => p.tipo === categoriaSelezionata));
              return;
            }
          
            // Normalizza: rimuove spazi, simboli, punti, virgole, trattini, underscore, "ohm", "Ω", ecc.
            const normalize = str =>
              (str || "")
                .toLowerCase()
                .replace(/[\s\-_,.]/g, "")      // rimuovi spazi, trattini, underscore, virgole, punti
                .replace(/[o0]hm|ohms|Ω|Ω/g, "ohm") // normalizza tutti i simboli ohm
                .replace(/ohm/g, "");           // togli "ohm" per confronto numerico/letterale
          
            const normalizedTerm = normalize(term);
          
            setProdottiFiltrati(
              prodotti.filter(p => {
                if (p.tipo !== categoriaSelezionata) return false;
                const nomeNorm = normalize(p.nome);
                const dettagliNorm = normalize(p.dettagli);
              
                // Cerca solo se il valore è isolato o seguito da "k", "r", "m", ecc. (es: "2k", "2k2", "2r2")
                // Non trova "12k" o "1,2k" se cerchi "2k"
                // Permette anche valori tipo "2k2", "2k7", "2r2", "2.2k", "2k 2", "2k,2"
                const regex = new RegExp(`(^|\\D)${normalizedTerm}(k|r|m)?(\\d*)($|\\D)`, "i");
              
                return (
                  regex.test(nomeNorm) ||
                  regex.test(dettagliNorm)
                );
              })
            );
          }}
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "24px",
            fontSize: "17px",
            border: `1.5px solid ${BLU_ACCENT3}`,
            borderRadius: "6px"
          }}
        />
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: "22px",
          marginBottom: "24px"
        }}>
          {prodottiFiltrati.map(p => (
            <div
              key={p.id}
              onClick={() => {
                setProdottoSelezionato(p);
                setPosizioneSelezionata(p.posizione);
                setMostraPaginaProdotto(true);
              }}
              style={{
                padding: "18px",
                borderRadius: "12px",
                background: prodottoSelezionato?.id === p.id
                  ? "linear-gradient(135deg, #e3f2fd 0%, #1976d2 100%)"
                  : p.quantita <= SOGLIA_BASSA
                  ? "linear-gradient(135deg, #ffcdd2 0%, #e57373 100%)"
                  : "linear-gradient(135deg, #f5fafd 0%, #bbdefb 100%)",
                border: prodottoSelezionato?.id === p.id
                  ? "3px solid #1976d2"
                  : p.quantita <= SOGLIA_BASSA
                  ? `2px solid ${ROSSO_ACCENT}`
                  : `1px solid ${BLU_ACCENT3}`,
                cursor: "pointer",
                boxShadow: prodottoSelezionato?.id === p.id
                  ? "0 0 18px #1976d2aa"
                  : "0 2px 8px #1565c033",
                fontWeight: 500
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: "18px", color: BLU_ACCENT2 }}>{p.nome}</div>
              <div style={{ fontSize: "13px", color: "#555", margin: "7px 0" }}>{p.dettagli}</div>
              <div style={{
                color: p.quantita <= SOGLIA_BASSA ? ROSSO_ACCENT : BLU_ACCENT2,
                fontWeight: "bold"
              }}>
                Qty: {p.quantita} - Pos: {p.posizione}
              </div>
              {prezziVisibili && p.prezzo !== undefined && p.prezzo !== null ? `Prezzo: ${p.prezzo.toFixed(3)} €` : "Prezzo: ••••"}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // --- HOME PAGE ---
  const renderHome = () => {
    // --- PALLINO ROSSO LAMPEGGIANTE ---
    const scorteBassePresenti = prodotti.some(p => p.quantita <= SOGLIA_BASSA);

    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(120deg, #fff 50%, #1565c0 50%)",        display: "flex",
        display: "flex",
        alignItems: "stretch",
        position: "relative",
        overflow: "hidden",
        fontFamily: "Inter, sans-serif" // <--- aggiungi questa riga
      }}>
        {/* Colonna categorie */}
        <div style={{
          flex: 1,
          zIndex: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "60px 40px 60px 80px",
          background: "transparent"
        }}>
          <h1 style={{
            marginBottom: "40px",
            color: BLU_ACCENT2,
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            textShadow: "0 2px 8px #1976d244",
            display: "flex",
            alignItems: "center",
            gap: "18px"
          }}>
            <img
              src="logo_tdyna.png"
              alt="Logo Tdyna"
              style={{ height: "96px", width: "120px", objectFit: "contain", marginRight: "10px" }}
            />
            Magazzino Tdyna
          </h1>
          <div style={{
            margin: "24px 0 32px 0",
            fontWeight: "bold",
            color: BLU_ACCENT2,
            fontSize: "1.3rem"
          }}>
            {!prezziVisibili && (
              <button
                onClick={chiediPasswordPrezzi}
                style={{
                  padding: "8px 14px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: 600,
                  marginBottom: "18px"
                }}
              >
                Sblocca prezzi
              </button>
            )}
            Valore totale magazzino: {prezziVisibili ? valoreTotaleMagazzino.toFixed(2) + " €" : "••••"}
          </div>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
            gap: "32px",
            position: "relative",
            zIndex: 4
          }}>
            {CATEGORIE.map(({ nome, icona }) => (
              <div
                key={nome}
                onClick={() => {
                  setCategoriaSelezionata(nome);
                  setProdottiFiltrati(prodotti.filter(p => p.tipo === nome));
                }}
                onMouseEnter={() => setHoverCategoria(nome)}
                onMouseLeave={() => setHoverCategoria(null)}
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  padding: "28px 10px 18px 10px",
                  borderRadius: "18px",
                  background: "rgba(255,255,255,0.4)",
                  backdropFilter: "blur(12px)",
                  boxShadow:
                    hoverCategoria === nome || categoriaSelezionata === nome
                      ? "0 12px 32px 0 rgba(25, 118, 210, 0.18)"
                      : "0 8px 32px 0 rgba(25, 118, 210, 0.10)",
                  border: `2.5px solid ${BLU_ACCENT3}`,
                  transition: "all 0.22s cubic-bezier(.4,2,.6,1)",
                  position: "relative",
                  transform:
                    hoverCategoria === nome || categoriaSelezionata === nome
                      ? "scale(1.06)"
                      : "scale(1)"
                }}
              >
                <div style={{
                  width: "110px",
                  height: "110px",
                  margin: "0 auto 14px auto",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #bbdefb 0%, #1976d2 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px #1976d244"
                }}>
                  <img
                    src={icona}
                    alt={nome}
                    style={{ width: "80px", height: "80px", filter: "drop-shadow(0 2px 6px #1976d244)" }}
                  />
                </div>
                <div style={{
                  fontWeight: "700",
                  color: BLU_ACCENT2,
                  fontSize: "1.1rem",
                  letterSpacing: 0.5
                }}>{nome}</div>
              </div>
            ))}
          </div>
          {/* Logo Meri Impianti in fondo alla colonna categorie */}
          <div style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "center"
        }}>
          <img
            src="logo_meri_impianti.png"
            alt="Logo Meri Impianti"
            style={{ width: "200px", height: "auto", objectFit: "contain" }}
          />
          </div>
        </div>
        {/* Colonna scaffale */}
        <div style={{
          flex: 1,
          zIndex: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px 80px 60px 40px",
          background: "transparent",
          position: "relative"
        }}>
          <div
            onClick={() => setMostraScaffale(true)}
            onMouseEnter={() => setHoverScaffale(true)}
            onMouseLeave={() => setHoverScaffale(false)}
            style={{
              width: "100%",
              minHeight: "350px",
              minWidth: "350px",
              maxWidth: "600px",
              aspectRatio: "4/5",
              background: `linear-gradient(120deg, #1976d2 60%, #0f2027 100%)`,
              borderRadius: "24px",
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 8px 32px 0 rgba(31,38,135,0.37)",
              position: "relative",
              overflow: "hidden",
              zIndex: 4
            }}
          >
            {/* SCRITTA ATTENZIONE + PALLINI LAMPEGGIANTI */}
            {scorteBassePresenti && (
              <div style={{
                position: "absolute",
                top: 18,
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 10
              }}>
                <div
                  style={{
                    marginBottom: 8,
                    padding: "4px 18px",
                    background: "#fff",
                    color: ROSSO_ACCENT,
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    letterSpacing: 1,
                    boxShadow: "0 2px 8px #e5393544",
                    border: `2px solid ${ROSSO_ACCENT}`,
                    animation: "lampeggia 1s infinite"
                  }}
                >
                  ATTENZIONE: prodotti in scarsa quantità!!
                </div>
                <div style={{
                  display: "flex",
                  gap: "10px"
                }}>
                  <div style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    background: "#e53935",
                    boxShadow: "0 0 12px 2px #e53935aa",
                    border: "2px solid #fff",
                    animation: "lampeggia 1s infinite"
                  }} />
                  <div style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    background: "#e53935",
                    boxShadow: "0 0 12px 2px #e53935aa",
                    border: "2px solid #fff",
                    animation: "lampeggia 1s infinite",
                    animationDelay: "0.2s"
                  }} />
                  <div style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    background: "#e53935",
                    boxShadow: "0 0 12px 2px #e53935aa",
                    border: "2px solid #fff",
                    animation: "lampeggia 1s infinite",
                    animationDelay: "0.4s"
                  }} />
                </div>
              </div>
            )}
            <img
              src={scaffaleImg}
              alt="Scaffale"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                opacity: 1,
                borderRadius: "24px",
                transition: "transform 0.3s", 
                transform: hoverScaffale ? "scale(1.04)" : "scale(1)", 
                boxShadow: "0 2px 16px #1976d244"
              }}
            />
            {hoverScaffale && (
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(60,60,60,0.85)",            
                transition: "background 0.3s, color 0.3s", // <--- aggiungi questa riga   
                padding: "24px 36px",
                borderRadius: "14px",
                fontSize: "1.8rem",
                fontWeight: "bold",
                textAlign: "center",
                color: "#fff", 
                boxShadow: "0 2px 18px #1976d244",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
              }}>
                Visualizza scaffale completo
                <div style={{ fontSize: "1rem", marginTop: "12px", fontWeight: 400, opacity: 0.85 }}>
                  Clicca per visualizzare
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // --- ROUTING ---
  if (mostraFormAggiunta) return renderFormAggiunta();
  if (mostraPaginaProdotto) return renderPaginaProdotto();
  if (visualizzaDettaglioPosizione) return renderDettaglioPosizione();
  if (mostraScaffale) {
    return (
      <div style={{ padding: "32px", background: BLU_CHIARO, minHeight: "100vh" }}>
        <button
          onClick={() => setMostraScaffale(false)}
          style={{
            padding: "10px 22px",
            marginBottom: "24px",
            background: BLU_ACCENT,
            color: BIANCO,
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "0 2px 8px #1976d244"
          }}
        >
          ← Torna alla home
        </button>
        <h2 style={{ color: BLU_ACCENT2 }}>Scaffale completo</h2>
        <p style={{ color: ROSSO_ACCENT, fontWeight: 600 }}>Sezioni in rosso: prodotti con scorte inferiori a 100 unità</p>
        {renderMappa()}
      </div>
    );
  }
  if (categoriaSelezionata) return renderRicercaProdotto();
  return renderHome();
};

export default App;